module.exports = __webpack_public_path__ + "static/media/unitCross.24e08af3.svg";